
import { tryFind, ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Record } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { list_type, record_type, string_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";

export const SearchResultTypeModule_all = ofArray(["tool", "toolWithQuantity", "consumable", "set", "user", "employee", "externalPerson", "subcontractor", "room", "project", "constructionSite", "student", "schoolClass", "vehicle", "storage", "location"]);

export function SearchResultTypeModule_key(resultType) {
    switch (resultType) {
        case "toolWithQuantity":
            return "tool_with_quantity";
        case "consumable":
            return "consumable";
        case "set":
            return "set";
        case "user":
            return "user";
        case "employee":
            return "employee";
        case "externalPerson":
            return "external_person";
        case "subcontractor":
            return "subcontractor";
        case "room":
            return "room";
        case "project":
            return "project";
        case "constructionSite":
            return "construction_site";
        case "student":
            return "student";
        case "schoolClass":
            return "school_class";
        case "vehicle":
            return "vehicle";
        case "storage":
            return "storage";
        case "location":
            return "location";
        default:
            return "tool";
    }
}

export function SearchResultTypeModule_isInventory(resultType) {
    switch (resultType) {
        case "tool":
        case "toolWithQuantity":
        case "consumable":
        case "set":
            return true;
        default:
            return false;
    }
}

export function SearchResultTypeModule_isReceiver(resultType) {
    switch (resultType) {
        case "user":
        case "employee":
        case "externalPerson":
        case "subcontractor":
        case "room":
        case "project":
        case "constructionSite":
        case "student":
        case "schoolClass":
        case "vehicle":
            return true;
        default:
            return false;
    }
}

export const SearchMatchFieldModule_all = ofArray(["name", "additionalName", "manufacturer", "model", "inventoryNumber", "serialNumber", "qrCode", "comment", "storageSpace", "description", "personnelNumber", "department", "email", "phone", "number", "numberPlate", "studentNumber", "customProperty"]);

export function SearchMatchFieldModule_key(field) {
    switch (field) {
        case "additionalName":
            return "additional_name";
        case "manufacturer":
            return "manufacturer";
        case "model":
            return "model";
        case "inventoryNumber":
            return "inventory_number";
        case "serialNumber":
            return "serial_number";
        case "qrCode":
            return "qr_code";
        case "comment":
            return "comment";
        case "storageSpace":
            return "storage_space";
        case "description":
            return "description";
        case "personnelNumber":
            return "personnel_number";
        case "department":
            return "department";
        case "email":
            return "email";
        case "phone":
            return "phone";
        case "number":
            return "number";
        case "numberPlate":
            return "number_plate";
        case "studentNumber":
            return "student_number";
        case "customProperty":
            return "custom_property";
        default:
            return "name";
    }
}

export function SearchMatchFieldModule_ofKey(fieldKey) {
    return tryFind((field) => (SearchMatchFieldModule_key(field) === fieldKey), SearchMatchFieldModule_all);
}

export class SearchMatchDto extends Record {
    constructor(Field, Value) {
        super();
        this.Field = Field;
        this.Value = Value;
    }
}

export function SearchMatchDto_$reflection() {
    return record_type("Shared.Search.SearchMatchDto", [], SearchMatchDto, () => [["Field", string_type], ["Value", string_type]]);
}

export class SearchResultDto extends Record {
    constructor(Id, Type, Title, Subtitle, StorageName, ImageUrl, Matches) {
        super();
        this.Id = Id;
        this.Type = Type;
        this.Title = Title;
        this.Subtitle = Subtitle;
        this.StorageName = StorageName;
        this.ImageUrl = ImageUrl;
        this.Matches = Matches;
    }
}

export function SearchResultDto_$reflection() {
    return record_type("Shared.Search.SearchResultDto", [], SearchResultDto, () => [["Id", string_type], ["Type", string_type], ["Title", string_type], ["Subtitle", string_type], ["StorageName", string_type], ["ImageUrl", string_type], ["Matches", list_type(SearchMatchDto_$reflection())]]);
}

export class SearchResponseDto extends Record {
    constructor(Query, Results) {
        super();
        this.Query = Query;
        this.Results = Results;
    }
}

export function SearchResponseDto_$reflection() {
    return record_type("Shared.Search.SearchResponseDto", [], SearchResponseDto, () => [["Query", string_type], ["Results", list_type(SearchResultDto_$reflection())]]);
}

export const minimumQueryLength = 2;

export const maximumResultsPerType = 20;

